import { render, staticRenderFns } from "./PopupRecordingsList.vue?vue&type=template&id=58040cf2&scoped=true&"
import script from "./PopupRecordingsList.vue?vue&type=script&lang=js&"
export * from "./PopupRecordingsList.vue?vue&type=script&lang=js&"
import style0 from "./PopupRecordingsList.vue?vue&type=style&index=0&id=58040cf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58040cf2",
  null
  
)

export default component.exports